import { styled, keyframes, css } from 'styled-components'

import { IoClose } from "react-icons/io5";

const fadeInDown = keyframes`
    from{
        opacity: 0;
        transform: translateY( -20px );
    }
    to{
        opacity: 1;
        transform: translateY( 0 );
    }
`

const sizeStyles = {
    sm: css`width: 400px;`,
    md: css`width: 550px;`,
    lg: css`width: 900px;`,
    xl: css`width: 1200px;`
};

const Container = styled.div`
    ${({ size }) => sizeStyles[size] || sizeStyles["md"]};
    max-width: 95%;
    max-height: 90%;
    border-radius: 12px;
    margin: auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    animation: ${ fadeInDown } .3s ease-out;
    position: relative;
`
const Header = styled.div`
    width: 100%;
    height: 40px;
    background-color: #263B4B;
    display: flex;
    flex-shrink: 0;
    svg{
        width: 30px;
        height: 30px;
        margin: auto 10px auto auto;
        color:rgb(190, 4, 4);
        cursor: pointer;
        transition: .3s;
        &:hover{
            scale: 1.3;
        }
    }
`
const Body = styled.div`
    width: 100%;
    flex: 1;
    background-color: #FFFFFF;
    padding: 20px;
    box-sizing: border-box;
    overflow: ${({ blockOverflow }) => blockOverflow ? 'visible' : 'auto' };
`

const Modal = ({ children, header, close, size = "md", blockOverflow = false }) => {

    return (
        <Container size={ size } >
            {
                header &&
                <Header>
                    <IoClose onClick={ close ?? (() => {}) } />
                </Header>
            }
            <Body blockOverflow={ blockOverflow } >{ children }</Body>
        </Container>
    )

}

export default Modal;